<template>
  <div class="records">
    <div>
      <div class="item flex-js-ac" v-for="(item, index) in list" :key="index">
        <span class="date">{{item.date}}</span>
        <div class="flex-ac" @click="goDetail(item)">
          <div class="flex-ac">
            <div class="score">{{item.score}}分</div>
            <van-icon name="arrow" size="0.16rem" />
          </div>
        </div>
      </div>
    </div>
    <div class="tips">~仅显示最近30条记录~</div>
	</div>
</template>

<script>
import { parametersCombine, isWeixin, fenxiang, isApp } from '../../assets/common/js/config'
import { customRequestAjax } from "@/axiosApi";
import wx from 'weixin-js-sdk'
export default {
  name: "skinRecords",
  data() {
    return {
			list: null,
			}
  },
  created() {
    this.getList()
    this.share()
  },
  methods: {
    share() {
			if (isWeixin()) {
				var arg = isApp(), shareInfo;
				shareInfo = {
					title: encodeURIComponent('皮肤测试'),
					desc: encodeURIComponent('AI皮肤测试，充分了解您你的皮肤状况！'),
					type: 'skinAnalysis',
					path: 'skinAnalysis',
					dataStr: 'type=skinAnalysis&emptybottle=emptybottle',
          imgx: this.staticImgUrl + 'Uploads/share/ndo1.png'
				}
				if (arg.indexOf('xcx') >= 0) {
          shareInfo = {
            type: 'skinAnalysis',
            title: encodeURIComponent('皮肤测试'),
            link: basepath + 'skinAnalysis?path=' + (this.$route.query.path ? this.$route.query.path : '') + arg,
            img: this.staticImgUrl + 'Uploads/share/ndo1.png'
          }
          wx.miniProgram.postMessage({data: shareInfo})
				} else {
					fenxiang(shareInfo)
				}
			}
		},
    getList() {
      let url = 'Wxmall/YiYuanApi/record'

      customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          let list = res.data.list
          list.forEach(item => {
            item.date = item.crt_time.substr(5)
          })
          this.list = list
        }
      });
    },
    goDetail(item) {
      let query = parametersCombine()
      query.orderid = item.id
      query.sex = item.sex
      query.source = 'records'
      this.$router.push({
        path: 'analysisDetail',
        query: query
      })
    },
  }
}
</script>

<style scoped lang="scss">
  .van-icon-arrow::before {
    margin-left: 0.1rem;
    color: #ccc;
  }
  .records {
    background: #fff;
    .item {
      line-height: 0.5rem;
      padding: 0 0.2rem;
      border-bottom: 1px solid #F5F5F9;;
      font-size: 0.14rem;
      .score {
        background-color: #FF3A80;
        border-radius: 0.25rem;
        line-height: 0.3rem;
        height: 0.3rem;
        width: 0.7rem;
        text-align: center;
        color: #fff;
      }
    }
    .tips {
      padding: 0.1rem 0;
      font-size: 0.12rem;
      text-align: center;
      color: #ccc;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/skinAnalysis/records.vue